<script setup>
defineProps({
  lookup: Object
});
</script>
<template>
  <table class="w-full table-fixed">
    <thead>
      <tr>
        <th class="pb-3 text-left md:w-2/12" scope="col">
          {{ $t('lookup.partials.dns.card_detail_txt.rdtype') }}
        </th>
        <th class="pb-3 text-left md:w-1/12" scope="col">TTL</th>
        <th class="pb-3 text-left" scope="col">
          {{ $t('lookup.partials.dns.card_detail_txt.entry') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(entry, i) in lookup.entries" :key="i">
        <td>TXT</td>
        <td>{{ lookup.ttl }}</td>
        <td class="break-words">
          {{ entry }}
        </td>
      </tr>
    </tbody>
  </table>
</template>
